import * as clmn from '../Defs/pipelinecolumnsdefs'

export function ToogleColumn(column, payload) {
  return { type: clmn.TOGGLE_COLUMN, column, payload};
}

export function initializeLayout(configuration) {
  return { type: clmn.INITIALIZE_LAYOUT, configuration };
}